// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"444":"5d9443862f3de9506ca0","663":"7f206e725617be3d42e5"}[chunkId] + ".css";
};